import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import React, { Fragment } from "react";

import { GhostBlock } from "@faire/retailer/components/GhostLoading/GhostBlock";
import { GhostText } from "@faire/retailer/components/GhostLoading/GhostTypography";

const FILTER_PROPS = {
  $height: "40px",
  $borderRadius: "20px",
};

export const SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton = () => {
  const numLongFilters = useResponsiveValue({
    mobileAndAbove: 1,
    tabletAndAbove: 3,
    desktopAndAbove: 4,
  });
  return (
    <Column>
      <GhostText />
      <Spacer width="2x" />
      <GhostBlock $width={getSpacing(160)} $height={getSpacing("5x")} />
      <Spacer size="1x" />
      <GhostBlock $width="50%" $height={getSpacing(20)} />
      <Spacer height={{ mobileAndAbove: "2x", desktopAndAbove: "4x" }} />
      {/* Filter row */}
      <Row style={{ overflowX: "hidden" }}>
        <GhostBlock $width="44px" {...FILTER_PROPS} />
        <Spacer width="2x" />
        <GhostBlock $width="44px" {...FILTER_PROPS} />
        {Array.from({ length: numLongFilters }).map((_, index) => (
          <Fragment key={index}>
            <Spacer width="2x" />
            <GhostBlock {...FILTER_PROPS} $width="120px" />
          </Fragment>
        ))}
      </Row>
      <Spacer height="2x" />
    </Column>
  );
};
